import * as React from "react";
import type { SVGProps } from "react";
const SvgNewsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="news_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M200.622 81.92c-73.318 0-139.182 63.652-139.182 150.692v517.734c0 87.04 65.864 150.774 139.182 150.774h242.36c1.23.082 2.458.164 3.687.164h375.44c75.325 0 140.492-63.734 140.492-147.784V252.928H801.382v-20.275c0-87.081-65.863-150.733-139.223-150.733H200.622zm600.76 262.062h79.053V753.46c0 27.976-22.937 56.73-58.327 56.73h-20.726V343.982zM719.258 810.19h-57.099v-.164H200.622c-32.194 0-57.057-27.443-57.057-59.679V232.653c0-32.236 24.863-59.679 57.057-59.679H662.16c32.236 0 57.099 27.443 57.099 59.679v577.536zm-452.65-409.6c0-25.109 18.35-45.466 40.96-45.466h246.498c22.65 0 41 20.357 41 45.466 0 25.108-18.35 45.465-40.96 45.465H307.61c-22.651 0-41.001-20.398-41.001-45.465zM471.9 537.109c22.692 0 41.083 20.357 41.083 45.465 0 25.15-18.432 45.548-41.083 45.548H307.65c-22.65 0-41.041-20.398-41.041-45.507 0-25.15 18.39-45.507 41.042-45.507H471.9z"
    />
  </svg>
);
export default SvgNewsIcon;
